<script setup lang="ts">
import Typography from '@components/Typography.vue';
import { type Color } from '@global-types/colors';

withDefaults(defineProps<{ color?: Color }>(), {
  color: 'black',
});
</script>

<template>
  <Typography
    variant="body-small-bold"
    :color="color"
    class="selection-item-header-tag"
  >
    <slot />
  </Typography>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-header-tag {
  border: 1px solid;
  border-radius: rem(20);
  padding: rem(4) rem(8);
  display: flex;
  align-items: center;
  gap: rem(8);
}
</style>
